type BaseButtonProps = {
  icon?: React.ReactNode;
  variant?: 'default' | 'outline';
  size?: 'xs' | 'sm' | 'lg';
  children: React.ReactNode;
};

export type ButtonProps = BaseButtonProps & {
  component?: 'button';
} & React.ComponentProps<'button'>;

export type LinkButtonProps = BaseButtonProps & {
  component: 'a';
} & React.ComponentProps<'a'>;

export function Button({
  icon,
  children,
  variant = 'default',
  size = 'lg',
  component = 'button',
  ...props
}: ButtonProps | LinkButtonProps) {
  const baseClasses =
    'group flex items-center gap-4 rounded-full font-bold text-sm transition-colors';

  const sizeClasses = {
    xs: 'px-4 py-1 h-8', // 32px height
    sm: 'px-6 py-2 h-10', // 40px height
    lg: 'px-8 py-3 h-12', // 48px height
  };

  const variantClasses = {
    default: 'bg-[#C09957] text-[#FFFFFF] hover:bg-[#CFA969]',
    outline: 'border border-[#C09957] text-[#C09957] hover:bg-[#CFA969] hover:text-white',
  };

  const className = [
    baseClasses,
    sizeClasses[size],
    variantClasses[variant],
    props.className || '',
  ].join(' ');

  const content = (
    <>
      {icon && icon}
      {children}
    </>
  );

  if (component === 'a') {
    return (
      <a {...(props as React.ComponentProps<'a'>)} className={className}>
        {content}
      </a>
    );
  }

  return (
    <button {...(props as React.ComponentProps<'button'>)} className={className}>
      {content}
    </button>
  );
}
